/*LIBRARY*/
import { connect } from "react-redux";
import bbox from "@turf/bbox";

/*COMPONENT*/
import SS_PIE_CHART_TEMP from "./SS_PIE_CHART_TEMP";

/*REDUX*/
import {
  set_value_insight,
  insight_update,
} from "../../App/actions/insight_v2";
import { show_top_result } from "../../App/actions/site_selections";

/*PICTURE*/
import ICON_VIEW from "../../Assets/jsx/ICON_VIEW";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const text_array = [
  "Sangat Sesuai",
  "Sesuai",
  "Cukup Sesuai",
  "Tidak Sesuai",
  "Sangat Tidak Sesuai",
];

const color_array = [
  "rgb(0,107,61)",
  "rgb(128,181,30)",
  "rgb(255,255,0)",
  "rgb(246,137,11)",
  "rgb(237,19,22)",
];

const SS_RESULT_TEMP = ({
  insight_reducer,
  set_value_insight,
  show_top_result,
  auth,
  insight_update,
  properties,
  layer,
}) => {
  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  let {
    top_result_limit,
    features_centroid_sample,

    value_array_filter,
    features_grid,
  } = insight_reducer;
  const { is_mobile } = properties;
  const { map_object } = layer;

  const on_change = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if (name === "top_result_limit") {
      let new_value = "";
      new_value = String(value);
      new_value = new_value.replace(/[^0-9]/g, "");
      new_value = Number(new_value);
      set_value_insight({
        key: name,
        value: new_value,
      });
    } else {
      set_value_insight({
        key: name,
        value: value,
      });
    }
  };

  const on_update_limit = () => {
    show_top_result({ ignore_modal: true });
  };

  const on_fly = (feature) => {
    if (map_object && feature) {
      const feature_object_selected = feature.feature_polygon;
      const geojson = {
        type: "FeatureCollection",
        features: [feature_object_selected],
      };
      const [min_longitude, min_latitude, max_longitude, max_latitude] =
        bbox(geojson);
      setTimeout(
        () => {
          map_object.fitBounds(
            [
              [min_longitude, min_latitude],
              [max_longitude, max_latitude],
            ],
            {
              padding: layer.padding_fly,
              maxZoom: layer.max_zoom,
              duration: 750,
            }
          );
          map_object.resize();
        },
        is_mobile ? 300 : 0
      );
    }
  };

  const on_filter = (value) => {
    if (!value_array_filter.includes(value)) {
      value_array_filter.push(value);
    } else {
      value_array_filter = value_array_filter.filter((item) => item !== value);
    }
    set_value_insight({
      key: "value_array_filter",
      value: value_array_filter,
    });
    const features_grid_filtered = features_grid.filter((feature) =>
      value_array_filter.includes(feature?.properties?.FINAL_STATUS_SCORE)
    );
    set_value_insight({
      key: "features_grid_filtered",
      value: features_grid_filtered,
    });
    insight_update();
  };

  const on_reset = () => {
    set_value_insight({
      key: "value_array_filter",
      value: [],
    });
    set_value_insight({
      key: "features_grid_filtered",
      value: features_grid,
    });
    insight_update();
  };

  return (
    <main className="margin_bottom_extra">
      <p className="text_bold margin_bottom">
        {dict?.["Result Preview (Not Saved Yet)"]?.[language]}
      </p>
      <p className="text_medium sub_color margin_bottom">
        {dict?.["Class Filter"]?.[language]}
      </p>

      <section className="container background_grey_light margin_bottom_extra two_container">
        <SS_PIE_CHART_TEMP />
        <div>
          <button
            className="button_small background_black margin_bottom"
            onClick={on_reset}
            data-mapid="clickReset"
          >
            Reset
          </button>
          <table className="table margin_top">
            <tbody>
              {color_array.map((color, idx) => {
                return (
                  <tr key={idx}>
                    <td>
                      <button
                        className={
                          value_array_filter.includes(text_array[idx])
                            ? "checklist_active"
                            : "checklist_not"
                        }
                        onClick={() => on_filter(text_array[idx])}
                        data-mapid={`clickTipe-${idx}`}
                      />
                    </td>
                    <td>
                      <div
                        style={{
                          backgroundColor: color,
                          width: "20px",
                          height: "20px",
                          border: "1px solid black",
                        }}
                      />
                    </td>
                    <td>{dict?.[text_array[idx]]?.[language]}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </section>

      <p className="text_medium sub_color margin_bottom">
        {dict?.["Number of Best Rankings Displayed"]?.[language]}
      </p>

      <section className="container background_grey_light two_container_equal margin_bottom_extra">
        <input
          name="top_result_limit"
          value={top_result_limit}
          type="text"
          min={1}
          onChange={(event) => on_change(event)}
          data-mapid="insertTopResult"
        />
        <button
          className="button_big background_black"
          onClick={() => on_update_limit()}
          data-mapid="clickUpdateLimit"
        >
          {dict?.["Change Amount"]?.[language]}
        </button>
      </section>

      <p className="text_medium sub_color margin_bottom">
        {dict?.["Result details"]?.[language]}
      </p>
      <section
        style={{ overflowY: "auto", maxHeight: "200px" }}
        className="container background_grey_light"
      >
        <table className="table full_width">
          <thead>
            <tr>
              <td style={{ width: "20px" }}></td>
              <td>{dict?.["Score numbers"]?.[language]}</td>
              <td>{dict?.["Class Score"]?.[language]}</td>
              <td style={{ width: "20px" }}></td>
            </tr>
          </thead>
          <tbody>
            {features_centroid_sample.map((feature, idx) => {
              return (
                <tr
                  key={idx}
                  style={{
                    backgroundColor: "#fff",
                  }}
                  className="cursor_pointer"
                  onClick={() => on_fly(feature)}
                >
                  <td>{feature.properties.index}</td>
                  <td>{feature.properties.FINAL_NUMBER_SCORE.toFixed(1)}</td>
                  <td>
                    {dict?.[feature.properties.FINAL_STATUS_SCORE]?.[language]}
                  </td>
                  <td>
                    <ICON_VIEW
                      color={"#696969"}
                      strokeWidth={3}
                      style={{ width: "27px", height: "27px" }}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  insight_reducer: state.insight_reducer,
  properties: state.properties,
  layer: state.layer,
});

export default connect(mapStateToProps, {
  set_value_insight,
  show_top_result,
  insight_update,
})(SS_RESULT_TEMP);
